export const    THUMBNAILICON = 'THUMBNAILICON';
export const    THUMBNAILICON_SUCCESS = 'THUMBNAILICON_SUCCESS';
export const    THUMBNAILICON_ERROR = 'THUMBNAILICON_ERROR';

export const    ADD_THUMBNAILICON = 'ADD_THUMBNAILICON';
export const    ADD_THUMBNAILICON_SUCCESS = 'ADD_THUMBNAILICON_SUCCESS';
export const    ADD_THUMBNAILICON_ERROR = 'ADD_THUMBNAILICON_ERROR';

export const    UPDATE_THUMBNAILICON = 'UPDATE_THUMBNAILICON';
export const    UPDATE_THUMBNAILICON_SUCCESS = 'UPDATE_THUMBNAILICON_SUCCESS';
export const    UPDATE_THUMBNAILICON_ERROR = 'UPDATE_THUMBNAILICON_ERROR';

export const DELETE_THUMBNAILICON = 'DELETE_THUMBNAILICON';
export const DELETE_THUMBNAILICON_SUCCESS= 'DELETE_THUMBNAILICON_SUCCESS';
export const DELETE_THUMBNAILICON_ERROR ='DELETE_THUMBNAILICON_ERROR';